import { createFileRoute, Outlet, useRouter } from '@tanstack/react-router'
import { useAuth } from '@/contexts/auth-context'
import UserSidebar from '@/components/sidebar/admin-panel-layout'
import { CurrencySelectionModal } from '@/components/modals/currency-selection-modal'
import { useState, useEffect } from 'react'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const { user, loading, isAuthenticated } = useAuth()
  const router = useRouter()
  const [showCurrencyModal, setShowCurrencyModal] = useState(false)

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      router.navigate({ to: '/login', replace: true })
    }
  }, [loading, isAuthenticated, router])

  useEffect(() => {
    if (!loading && isAuthenticated && user && !user.base_currency_id) {
      setShowCurrencyModal(true)
    }
  }, [loading, isAuthenticated, user])

  if (loading || !isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  return (
    <UserSidebar>
      <Outlet />
      <CurrencySelectionModal
        open={showCurrencyModal}
        onClose={() => setShowCurrencyModal(false)}
        isRequired={!user?.base_currency_id}
        showThemeSelector={!user?.base_currency_id}
      />
    </UserSidebar>
  )
}
